export const stdLibPrefix = "Library/Std/";
export const fsEndpoint = "/.fs";
